// extracted by mini-css-extract-plugin
module.exports = {"cls1":"SideNavigationItem-module--cls1--17Z5O","cls2":"SideNavigationItem-module--cls2--I9xtK SideNavigationItem-module--cls1--17Z5O"};